import { createSelector } from 'reselect';

const topifyPresetsSelector = state => state.topifyPresets;
const userStateSelector = state => state.ustate;

export default createSelector(
	[ topifyPresetsSelector, userStateSelector ],
	( topifyPresets, ustate ) => {
		return {
			siteTitle: topifyPresets.forumSite.f_title,
			siteUrl: topifyPresets.forumSite.url,
			isVS: topifyPresets.forumSite.isVS,
			registerUrl: ustate.registerUrl
		}
	}
);



// WEBPACK FOOTER //
// ./src/selectors/registerUserSelector.js